/* eslint-disable no-unused-vars */
import { Box, Tab, Tabs } from "@mui/material";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Store } from "../../utils/Store.js";
import ConfigList from "./config/ConfigList.jsx";
import DashBoardSettings from "./DashBoardSetting.jsx";
import DeliItemSettings from "./DeliItemSettings.jsx";
import ProductSettings from "./ProductSettings.jsx";
import SaleSettings from "./SaleSettings.jsx";
import UserSettingTab from "./security/UserSettingTab.jsx";
import StoreSettings from "./StoreSettings.jsx";
import SuperAdminTab from "./SuperAdminTab.jsx";
import TaxList from "./tax/TaxList";
import TerminalList from "./terminal/TerminalList.jsx";
import KOTList from "./kot/KOTList";
import FloorList from "./floor/FloorList";
import EmployeeList from "./employee/EmployeeList.jsx";
import FxRateList from "./fxrate/FxRateList";

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && (
        <Box p={3}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
export default function SettingList(props) {
  const { t } = useTranslation();
  const translate = t;

  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let token = Store.get("w_refreshToken");
    if (Store.parseJwt(token).sub == "admin") {
      setIsAdmin(true);
    }
  }, []);

  var biRef = {};

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div>
      <Tabs value={value} onChange={handleChange}>
        <Tab label={translate("Store")} />
        <Tab label={translate("Configurations")} />
        <Tab label={translate("Security")} />
        <Tab label={translate("Employees")} />
        {isAdmin && <Tab label={translate("Super Admin")} />}
      </Tabs>

      <TabPanel value={value} index={0}>
        <StoreSettings
          messagHandler={props.showMessage}
          showMessage={props.showMessage}
        ></StoreSettings>
        <ProductSettings
          messagHandler={props.showMessage}
          showMessage={props.showMessage}
        ></ProductSettings>
        <DeliItemSettings
          messagHandler={props.showMessage}
          showMessage={props.showMessage}
        ></DeliItemSettings>
        <SaleSettings
          messagHandler={props.showMessage}
          showMessage={props.showMessage}
          context={props.context}
        ></SaleSettings>
        <DashBoardSettings
          messagHandler={props.showMessage}
          showMessage={props.showMessage}
        ></DashBoardSettings>
        <TaxList
          messagHandler={props.showMessage}
          showMessage={props.showMessage}
        ></TaxList>
        <TerminalList
          showMessage={props.showMessage}
          context={props.context}
        ></TerminalList>
        <FxRateList
          context={props.context}
          showMessage={props.showMessage}
        ></FxRateList>
        {props.context.appType === "R_POS" && (
          <KOTList
            showMessage={props.showMessage}
            showProgress={props.showProgress}
            hideProgress={props.hideProgress}
          ></KOTList>
        )}
        {props.context.appType === "R_POS" && (
          <FloorList
            showMessage={props.showMessage}
            showProgress={props.showProgress}
            hideProgress={props.hideProgress}
          ></FloorList>
        )}
      </TabPanel>

      <TabPanel value={value} index={1}>
        <ConfigList showMessage={props.showMessage}></ConfigList>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <UserSettingTab showMessage={props.showMessage}></UserSettingTab>
      </TabPanel>
      <TabPanel value={value} index={3}>
        <EmployeeList showMessage={props.showMessage}></EmployeeList>
      </TabPanel>
      <TabPanel value={value} index={4}>
        <SuperAdminTab
          messagHandler={props.showMessage}
          showMessage={props.showMessage}
          context={props.context}
          setAlert={props.setAlert}
        ></SuperAdminTab>
      </TabPanel>
    </div>
    /*
    <Grid container>
      <Grid item xs={12} sm={6}>
        <ProductSettings messagHandler={props.showMessage}></ProductSettings>
      </Grid>
      <Grid item xs={12} sm={6}>
        <SaleSettings messagHandler={props.showMessage}></SaleSettings>
      </Grid>
      <Grid item xs={12} sm={6} style={{ marginBottom: 10 }}>
        <TaxList messagHandler={props.showMessage}></TaxList>
      </Grid>
      <Grid item xs={12} sm={12}>
        <UserSettings></UserSettings>
      </Grid>
      <Grid item xs={12} sm={12}>
        <ConfigList></ConfigList>
      </Grid>
      <Grid item xs={12} sm={12}>
        <TerminalList></TerminalList>
        <DeliItemSettings messagHandler={props.showMessage}></DeliItemSettings>
      </Grid>
          </Grid>*/
  );
}
